<script type="text/ecmascript-6">
    import DesignerQuestionDoorDripColour from "../DesignerQuestionDoorDripColour.vue";
    import Question from "../mixin/Question.vue";

    export default {
        mixins: [
            DesignerQuestionDoorDripColour,
            Question,
        ],
        computed: {
            panel_required(){
                return this.filtered_option_list.length > 1
                    && this.doorRange !== 97
                    && this.doorRange !== 98;
            }
        },
    }
</script>
